import { render, staticRenderFns } from "./AppellantApplyForLeaveJourneyMap.vue?vue&type=template&id=4a90eb0f&scoped=true"
import script from "./AppellantApplyForLeaveJourneyMap.vue?vue&type=script&lang=ts"
export * from "./AppellantApplyForLeaveJourneyMap.vue?vue&type=script&lang=ts"
import style0 from "./AppellantApplyForLeaveJourneyMap.vue?vue&type=style&index=0&id=4a90eb0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90eb0f",
  null
  
)

export default component.exports